<template>
  <div class="chart-block">
    <h3>
      <a :href="url" target="_blank"> {{ chartName }}</a>
      <el-tooltip class="item" effect="dark" placement="bottom">
        <div v-html="tip" slot="content"></div>
        <svg-icon
          name="faq"
          size="20"
          @click.native="faq()"
          color="#53b1e7"
        ></svg-icon>
      </el-tooltip>
      <span>{{ updated }}</span>

      <el-radio-group
        v-model="marketType"
        size="mini"
        class="opt"
        @change="queryData()"
        :disable="loading"
      >
        <el-radio-button label="整体市场价格指数"></el-radio-button>
        <el-radio-button label="轿车"></el-radio-button>
        <el-radio-button label="SUV"></el-radio-button>
        <el-radio-button label="MPV"></el-radio-button>
      </el-radio-group>
    </h3>
    <div style="display: flex" v-loading="loading">
      <div class="gain-left">
        <div class="total">{{ index() }}</div>
        <div class="y">{{ date() }}</div>
      </div>
      <div
        id="chart_gain_ch_index"
        class="chart-box"
        style="padding-bottom: 9px; flex: auto"
      ></div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import chartsOptions from "@/store/local_data/ChartsTemplate";
import { strToYeayAndMonth } from "@/plugins/DateTimeFormater.js";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
export default {
  props: {
    chartName: {
      type: String,
      default: "MADE价格指数",
    },
  },
  data() {
    return {
      url: "#",
      tip: "整体市场价格指数",
      chartId: "gain_index",
      chartOption: {},
      myChart: null,
      updated: "",
      marketType: "整体市场价格指数",
      jsonData: null,
      loading: false,
      chartsData: [],
      current: {},
    };
  },
  mounted() {
    this.chartOption = chartsOptions.gain_price;

    this.getChartList({
      handle: this.updateChart,
    });
  },
  methods: {
    ...mapActions("home", [
      "queryChartConfigs",
      "queryChartUpdate",
      "getChartList",
      "queryChartBuild",
    ]),
    ...mapActions("gain", ["getMarketsByName", "queryGainData"]),
    ...mapMutations("gain", ["clearGainData", "clearMarketTags"]),

    async updateChart() {
      var self = this;
      this.myChart = echarts.init(document.getElementById("chart_gain_ch_index"));
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });

     // var info = await this.getChartByName(this.chartId);

     // this.url = info.url;
      this.queryData();
    },
    openWin() {
      //alert('test');

      this.$emit("indexWindow", "test");
      console.log("abcdef");
    },
    queryData() {
     var tags = "A0_SUV;A_SUV;B_SUV;C_SUV;A0;A;B;C;A0_MPV;A_MPV;B_MPV;C_MPV";
      
       if(this.marketType =="轿车")
      {
        tags = "A;A0;B;C"
      }else if(this.marketType =="SUV")
      {
          tags = "A0_SUV;A_SUV;B_SUV;C_SUV"
      }else if(this.marketType =="MPV")
      {
            tags = "MPV";
      } else if(this.marketType=="整体市场价格指数")
      {
        tags = "A0_SUV;A_SUV;B_SUV;C_SUV;A0;A;B;C;A0_MPV;A_MPV;B_MPV;C_MPV";
      }

      let nowDate = new Date();
      let year = nowDate.getFullYear();
      var m = nowDate.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let postData = {
        marketTags: tags,
        startMonth: "2021-01",
        endMonth: year + "-" + m,
      };
      var self = this;
      this.queryGainData({ params: postData, handle: (res) => {

        self.bindChart();
      } });
    },
    bindChart() {
      let opts = chartsOptions.gain_price;
      opts.series[0].data = [];
      opts.series[1].data = [];
      opts.series[2].data = [];

      let s2020 = this.gainData
        .filter((x) => x.month.indexOf("2021") >= 0)
        .map((z) => (z.price_index ).toFixed(2));
      let s2021 = this.gainData
        .filter((x) => x.month.indexOf("2022") >= 0)
        .map((z) => (z.price_index).toFixed(2));
      let s2022 = this.gainData
        .filter((x) => x.month.indexOf("2023") >= 0)
        .map((z) => (z.price_index ).toFixed(2));
      var chk = function (year, year_arr, opt) {
        if (year_arr.length == 0) {
          let idx = opt.legend.data.indexOf(year);
          if (idx >= 0) opts.legend.data.splice(idx, 1);
        } else {
          let idx = opt.legend.data.indexOf(year);
          if (idx <= 0) opts.legend.data.push(year);
        }
      };
      chk("2021", s2020, opts);
      chk("2022", s2021, opts);
      chk("2023", s2022, opts);
      opts.series[0].data = s2020;
      opts.series[1].data = s2021;
      opts.series[2].data = s2022;

      this.myChart.setOption(opts);
      this.loading = false;
    },
  },
  computed: {
    ...mapGetters("home", {
      chartList: "chartList",
      getChartByName: "getChartByName",
    }),
        ...mapGetters("gain", ["marketTags", "gainData"]),
    index() {
      return function () {
        if (this.current && this.current.value) return this.current.value;
        return 0;
      };
    },
    date() {
      return function () {
        if (this.current && this.current.date) return this.current.date;
        return "...";
      };
    },
  },
  watch: {
    gainData(newValue) {
      
      //this.bindChart();
    },
  },
  created() {},
};
</script>
<style scoped>
.gain-left {
  display: none;
  flex: auto;
  width: 0px;
  text-align: left;
  padding: 0px 0 0 1px;
  position: relative;
}
.gain-left .total {
  position: absolute;
  color: #5f96e6;
  font-size: 2em;
  top: 20%;
}
.gain-left .y {
  color: #bcbdc1;
  position: absolute;
  bottom: 30%;
}
 #chart_gain_ch_index {
        min-height: 300px;
        min-width: 300px;
    }
</style>